//@ts-ignore
import serviceKeyCJS from '../commonjs/service-key.js'
export const { serviceKey } = serviceKeyCJS as { serviceKey: string }
